import HeroSection from "./components/HeroSection";
import ImpactSection from "./components/ImpactSection";
import VisionSection from "./components/VisionSection";
import ProgrammesSection from "./components/ProgrammesSection";
import PartnersSection from "./components/PartnersSection";
import InnovationPathway from "./components/InnovationPathway";
import InnovationCellsSection from "./components/InnovationCellsSection";
import ResearchSection from "./components/ResearchSection";
import RecognitionSection from "./components/RecognitionSection";
import ExpoSection from "./components/ExpoSection";
import CapacitySection from "./components/CapacitySection";
import NewsSection from "./components/NewsSection";
import GovernanceSection from "./components/GovernanceSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <ImpactSection />
      <VisionSection />
      <ProgrammesSection />
      <PartnersSection />
      <InnovationPathway />
      <InnovationCellsSection />
      <ResearchSection />
      <RecognitionSection />
      <ExpoSection />
      <CapacitySection />
      <NewsSection />
      <GovernanceSection />
      <ContactSection />
    </main>
  );
}